import React, { useState } from 'react';
import { connect } from '../../redux/store';
import { Link } from '@reach/router';
import { UncontrolledTooltip } from 'reactstrap';
import { CardCol, CardRow, CardCorner, C } from '@kineticdata/bundle-common';
import { ActionMetaWrapper } from './ActionMetaWrapper';
import { ActionModal } from './Action';
import * as helpers from '../../utils';
import { Form } from '../../models';
import { I18n } from '@kineticdata/react';

export const ActionCard = connect(state => ({
  profile: state.app.profile,
  mobile: state.app.layoutSize === 'small',
}))(props => {
  const { submission, path, components = {} } = props;
  // If external prop is true, clicking the card should open modal and right
  // side action should open action in new tab
  const CardTag = !props.external ? components.Link || Link : 'button';
  const form = Form(submission.form || { type: submission.type });
  const color = helpers.getActionStatusColor(submission);

  // State for action modal
  const [decision, setDecision] = useState(null);
  const complete = e => {
    e.preventDefault();
    setDecision('complete');
  };
  const cancel = e => {
    e.preventDefault();
    setDecision('cancel');
  };
  const open = e => {
    e.preventDefault();
    setDecision('');
  };
  const reset = () => setDecision(null);

  return (
    <>
      <ActionMetaWrapper submission={submission}>
        {meta => (
          <CardTag
            className="card"
            to={!props.external ? path : undefined}
            onClick={props.external ? open : undefined}
          >
            {meta.isLocked &&
              !meta.isLockedByMe && (
                <>
                  <CardCorner
                    id={`lock1-${submission.id}`}
                    className="card__corner--danger"
                    tag="span"
                    icon="fa fa-lock"
                  />
                  <UncontrolledTooltip
                    placement="right"
                    target={`lock1-${submission.id}`}
                    delay={0}
                    trigger="hover focus"
                  >
                    <I18n
                      render={translate =>
                        translate(
                          `This action is currently locked by another user. Lock expires in ~%d minute%p.`,
                        )
                          .replace('%d', meta.lockMinutesLeft)
                          .replace('%p', meta.lockMinutesLeft !== 1 ? 's' : '')
                      }
                    />
                  </UncontrolledTooltip>
                </>
              )}
            <CardRow>
              <CardRow type="prepend" className="text-muted">
                <span className={`fa fa-fw fa-2x fa-${form.icon}`} />
              </CardRow>

              <CardCol>
                <CardRow className="text-muted">
                  <span>
                    <strong>
                      <I18n>
                        {submission.values[C.FIELD_REQUEST_FORM_NAME] ||
                          form.name}
                      </I18n>
                    </strong>
                    {!!submission.values[C.FIELD_REQUEST_SUBMISSION_ID] && (
                      <>
                        {' \u00b7 '}
                        {submission.values[C.FIELD_REQUEST_SUBMISSION_ID]
                          .slice(-6)
                          .toUpperCase()}
                      </>
                    )}
                  </span>
                </CardRow>
                <CardRow type="subtitle">
                  <I18n>
                    {submission.values[C.FIELD_ACTION_SUMMARY] ||
                      submission.label}
                  </I18n>
                </CardRow>
                {!!submission.values[C.FIELD_ACTION_DETAILS] && (
                  <CardRow className="text-muted mb-1">
                    <I18n>{submission.values[C.FIELD_ACTION_DETAILS]}</I18n>
                  </CardRow>
                )}
                <CardRow type="meta" className="text-muted">
                  <dl className="flat">
                    {[
                      {
                        value: (
                          <span
                            className={`badge badge-${color} badge-stylized text-muted`}
                          >
                            <I18n>{helpers.getStatus(submission)}</I18n>
                          </span>
                        ),
                      },
                      { label: 'Created', value: meta.showCreatedDate() },
                      { label: 'Submitter', value: meta.showSubmitter() },
                      { label: 'Due', value: meta.showDueDate() },
                      { label: 'Completed', value: meta.showCompletedDate() },
                      { value: meta.showIssues() },
                    ]
                      .filter(m => !!m.value)
                      .map(({ label, value }, i) => (
                        <div key={`meta-${i}`}>
                          {label && (
                            <dt>
                              <I18n>{label}</I18n>
                            </dt>
                          )}
                          {value && <dd>{value}</dd>}
                        </div>
                      ))}
                  </dl>
                </CardRow>
              </CardCol>

              {!props.external ? (
                submission.coreState === C.CORE_STATE_DRAFT &&
                !props.mobile && (
                  <CardRow type="append">
                    <button
                      className="btn btn-icon-info px-2 card-icon-action"
                      onClick={complete}
                      title="Complete"
                    >
                      <span className="fa fa-fw fa-lg fa-check-circle" />
                    </button>
                    <button
                      className="btn btn-icon-danger px-2 card-icon-action"
                      onClick={cancel}
                      title="Cancel"
                    >
                      <span className="fa fa-fw fa-lg fa-times-circle" />
                    </button>
                  </CardRow>
                )
              ) : (
                <CardRow type="append">
                  <Link
                    className="btn btn-icon-info px-2 card-icon-action"
                    to={path}
                    onClick={e => e.stopPropagation()}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open in New Tab"
                  >
                    <span className="fa fa-fw fa-lg fa-external-link-alt" />
                  </Link>
                </CardRow>
              )}
            </CardRow>
          </CardTag>
        )}
      </ActionMetaWrapper>
      {decision !== null && (
        <ActionModal
          submissionId={submission.id}
          toggle={reset}
          isCompleted={decision === 'complete'}
          isCancelled={decision === 'cancel'}
          completed={() => {
            reset();
            if (typeof props.reload === 'function') {
              props.reload();
            }
          }}
        />
      )}
    </>
  );
});
